/**
 * Returns whether this is running in a browser.
 *
 * Based on: https://www.npmjs.com/package/exenv and should match what React uses.
 *
 * This is a function to allow mocking in tests.
 */
export const isBrowser = (): boolean =>
  !!(typeof window !== 'undefined' && window.document && window.document.createElement);
